import React from 'react';
import Header from "./Header";
import Banner from "./Banner";
import About from "./About";
import Messaging from "./Messaging";
import Services from "./Services";
import Gallery from "./Gallery";
import Team from "./Team";
import Pets from "./Pets";
import PetRequestForm from "./PetRequestForm";
import Forms from './Forms';
import Contact from "./Contact";
import MessagePopup from "./MessagePopup";
import VideoPopup from "./VideoPopup";
import Testimonial from "./Testimonial";
import Footer from "./Footer";
import {Carousel} from "react-responsive-carousel";
import {businessLogo, businessTitle, findChild, formatTimeAgo, updateAnalytics} from "./utils";
import blueColorLoader from './assets/images/Loaders/BlueColorLoader.gif';
import purpleColorLoader from './assets/images/Loaders/PurpleColorLoader.gif';
import greenColorLoader from './assets/images/Loaders/GreenColorLoader.gif';
import orangeColorLoader from './assets/images/Loaders/OrangeColorLoader.gif';
import pinkColorLoader from './assets/images/Loaders/PinkColorLoader.gif';
import redColorLoader from './assets/images/Loaders/RedColorLoader.gif';
import brownColorLoader from './assets/images/Loaders/BrownColorLoader.gif';
import charcoalColorLoader from './assets/images/Loaders/CharcoalColorLoader.gif';

import ReactPlayer from 'react-player'
import {TikTok} from 'react-tiktok';
import PetRecords from './PetRecords'
import comingSoonLabel from "./assets/images/Coming_Soon.png";
import availableLabel from "./assets/images/Available.png";
import femaleLabel from "./assets/images/female-square.png";
import maleLabel from "./assets/images/male-square.png";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bodyOverflow: false,
            messageList: [],
            testimonialList: [],
            adopts: [],
            messageOverlayShow: false,
            messageOverlayPosition: 0,
            galleryList: [],
            galleryOverlayShow: false,
            galleryOverlayPosition: 0,
            galleryCount: 0,
            teamList: [],
            teamOverlayShow: false,
            teamOverlayPosition: 0,
            petOverlayShow: false,
            petOverlayPosition: 0,
            submitMessage: '',
            contactOverlayShow: false,
            teamStatus: null,
            formStatus: null,
            testimonialStatus: null,
            loaded: false,
            showFullProfile: false,
            condition: false,
            activeVideo: null,
            sliderImages: null,
            duration: 4000,
            showFullScreenImg: false,
            showRecordsOverlay: false,
            messageEnabled: null,
            locationOverlayShow: false,
            locations: null,
            latitude: null,
            longitude: null,
            locationListStatus: false,
            locationDisplayName: '',
            selectedMenu: 0,
            showParent: false,
            isFoundationDetails: true,
            showFoundationPairingDetails: false,
            isPairingPopup: true,
            showLitterDetails: false,
            isPairingFlow: false
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let elems = document.getElementsByClassName('unToggled');
        for (let linkElem of elems) {
            let descElement = findChild(linkElem.parentElement, 'P');
            if (descElement && descElement.scrollHeight == descElement.offsetHeight) {
                linkElem.classList.add('hiddenClassForLink');
            }
        }

        elems = document.getElementsByClassName('toggled');
        for (let linkElem of elems) {
            let descElement = findChild(linkElem.parentElement, 'P');
            if (descElement.innerHTML.length < 150) {
                linkElem.classList.add('hiddenClassForLink');
            }
        }
    }

    componentDidMount() {
        window.scrollTo({top: 0});
        Promise.all([
            fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/active_items")
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            teamStatus: result.team_active,
                            formStatus: result.form_active,
                            testimonialStatus: result.testimonial_active,
                            serviceStatus: result.service_active,
                            serviceType: result.web_service_type,
                            businessName: result.profile_name,
                            businessLogo: result.profile_image,
                            headerInfo: result.header_info,
                            isPetDistributor: result.is_pet_distributor,
                            adoptType: result.adopt_type,
                            messageEnabled: result.is_message_enabled,
                            locationListStatus: result.location_active,
                            locationDisplayName: result.location_display_name
                        }, function () {

                        });
                    },
                    (error) => {
                        this.setState({
                            teamStatus: false,
                            formStatus: false,
                            testimonialStatus: false
                        });
                    }
                )
        ]).then(() => {
            this.fetchData();
        })

    }

    fetchData() {
        Promise.all([
            fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/slider_images")
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            sliderImages: result.images,
                            duration: result.duration,
                            animation: result.animation
                        });
                    },
                    (error) => {
                        this.setState({
                            bannerDetails: null
                        });
                    }
                ),
            fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/desc")
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            bannerDetails: result
                        });
                    },
                    (error) => {
                        this.setState({
                            bannerDetails: null
                        });
                    }
                ),

            fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/about")
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            aboutDetails: result
                        });
                    },
                    (error) => {
                        this.setState({
                            aboutDetails: null
                        });
                    }
                )

        ]).then(() => {
            this.setState({
                loaded: true
            });

            if (this.state.messageEnabled) {
                this.getMessagesList()
            }

            if (this.state.serviceType === 'List') {
                this.getServicesList()
            }

            if (this.state.serviceType === 'Category') {
                this.getServicesCategory()
            }

            if (this.state.serviceType === 'Appointment') {
                this.getServicesAppointment()
            }

            fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/gallery")
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            galleryList: result.gallery,
                            galleryCount: result.count
                        });
                    },
                    (error) => {
                        this.setState({
                            galleryList: [],
                            galleryCount: 0
                        });
                    }
                )

            if (this.state.teamStatus) {
                this.getTeamDetails()
            }

            if (this.state.formStatus) {
                this.getFormDetails()
            }

            if (this.state.testimonialStatus) {
                this.getTestimonials()
            }

            if (this.state.isPetDistributor) {
                this.getAdoptionPets()
            }

            fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/contact")
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            contactDetails: result
                        });
                    },
                    (error) => {
                        this.setState({
                            contactDetails: null
                        });
                    }
                )

            if (this.state.locationListStatus) {
                this.getLocationList()
            }
        })
    }

    getMessagesList = () => {
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/messages")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        messageList: result.messages_list
                    });
                },
                (error) => {
                    this.setState({
                        messageList: []
                    });
                }
            )
    }

    getTeamDetails = () => {
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/team")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        teamList: result.team
                    });
                },
                (error) => {
                    this.setState({
                        teamList: []
                    });
                }
            )
    }

    getFormDetails = () => {
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/forms")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        formsList: result.forms
                    });
                },
                (error) => {
                    this.setState({
                        formsList: []
                    });
                }
            )
    }

    getTestimonials = () => {
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/testimonials")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        testimonialList: result.testimonials
                    });
                },
                (error) => {
                    this.setState({
                        testimonialList: []
                    });
                }
            )
    }

    getAdoptionPets = () => {
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/adoptions")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        adopts: result.adoptions,
                        foundations: result.foundations,
                        pairings: result.pairings,
                        adopt_default_view: result.default_view,
                        petFields: result.pet_fields
                    });
                },
                (error) => {
                    this.setState({
                        adopts: []
                    });
                }
            )
    }

    getServicesList() {
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/listServices")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        serviceDetails: result
                    });
                },
                (error) => {
                    this.setState({
                        serviceDetails: null
                    });
                }
            )
    }

    getServicesCategory() {
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/services")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        serviceDetails: result

                    });
                },
                (error) => {
                    this.setState({
                        serviceDetails: null
                    });
                }
            )
    }

    getServicesAppointment() {
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/appointment_services")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        serviceDetails: result

                    });
                },
                (error) => {
                    this.setState({
                        serviceDetails: null
                    });
                }
            )
    }

    getLocationList = () => {
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/locations")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        locations: result.locations
                    });
                },
                (error) => {
                    this.setState({
                        contactDetails: null
                    });
                }
            );
    }

    imageSlider = () => {
        return (
            <Carousel
                showArrows={true}
                autoPlay={true}
                showThumbs={false}
                width={"100%"}
                infiniteLoop={true}
                interval={this.state.duration}
                animationHandler={this.state.animation}
                onSwipeEnd={false}
                onSwipeStart={false}
                onSwipeMove={false}
                swipeable={false}
            >
                {this.state.sliderImages && this.state.sliderImages.map((image, index) => (
                    <div>
                        <img src={image.url} alt={document.title}/>
                    </div>
                ))}
            </Carousel>
        )
    }

    triggerCotactForm = () => {
        this.setState({
            showContactFomModal: !this.state.showContactFomModal
        })
    }

    render() {
        if (this.state.loaded) {
            return (

                <div>
                    <main>
                        <Header
                            formStatus={this.state.formStatus}
                            teamStatus={this.state.teamStatus}
                            testimonialStatus={this.state.testimonialStatus}
                            businessName={this.state.businessName}
                            businessLogo={this.state.businessLogo}
                            serviceStatus={this.state.serviceStatus}
                            headerInfo={this.state.headerInfo}
                            isPetDistributor={this.state.isPetDistributor}
                            adoptType={this.state.adoptType}
                            PCBID={this.props.PCBID}
                            messageEnabled={this.state.messageEnabled}
                            showLocationModal={this.showLocationModal}
                            locationListStatus={this.state.locationListStatus}
                            locationDisplayName={this.state.locationDisplayName}
                        />

                        <div className="wrap-top-bg">
                            <div className="wrap-banner-section" id="banner">

                                <div class="video-container">
                                    {this.imageSlider()}

                                </div>
                                <Banner
                                    PCBID={this.props.PCBID}
                                    bannerDetails={this.state.bannerDetails}
                                    headerInfo={this.state.headerInfo}
                                />
                            </div>
                            <div className="wrap-btm-bg">
                                <About
                                    PCBID={this.props.PCBID}
                                    color={this.props.color}
                                    aboutDetails={this.state.aboutDetails}
                                />
                                {this.showTeamList()}


                            </div>
                        </div>

                        {this.showAdoptionPetList()}

                        {this.showMessages()}

                        {this.showServices()}

                        <Gallery
                            galleryList={this.state.galleryList}
                            color={this.props.color}
                            onClick={i => this.showGalleryModal(i)}
                        />


                        {this.showFormList()}

                        {this.showTestimonialList()}


                        <Contact
                            onClick={i => this.showContactModal(i)}
                            PCBID={this.props.PCBID}
                            color={this.props.color}
                            contactDetails={this.state.contactDetails}
                            showLocationModal={this.showLocationModal}
                            locationListStatus={this.state.locationListStatus}
                            locationDisplayName={this.state.locationDisplayName}
                        />
                    </main>

                    <MessagePopup onClose={this.showMessageModal} show={this.state.messageOverlayShow}
                                  setClassName="messageModal">
                        <Carousel
                            selectedItem={this.state.messageOverlayPosition}
                            showThumbs={false}
                            onClickItem={false}
                            onSwipeEnd={false}
                            onSwipeStart={false}
                            onSwipeMove={false}
                            swipeable={false}
                            infiniteLoop={true}
                            centerMode={true}
                            onChange={(e) => {
                                this.handleSelectedMessageItem(e)
                            }}
                            centerSlidePercentage={100}
                        >
                            {this.state.messageList.map((message, index) => (
                                this.messageViewer(message)
                            ))}
                        </Carousel>
                    </MessagePopup>

                    <MessagePopup onClose={this.showGalleryModal} show={this.state.galleryOverlayShow}
                                  setClassName="galleryModal">
                        <Carousel
                            selectedItem={this.state.galleryOverlayPosition}
                            showThumbs={false}
                            onClickItem={false}
                            onSwipeEnd={false}
                            onSwipeStart={false}
                            onSwipeMove={false}
                            swipeable={false}
                            infiniteLoop={true}
                            centerMode={true}
                            centerSlidePercentage={100}
                        >
                            {this.state.galleryList.map((image, index) => (
                                <div className="gallery-list__item" key={index}>
                                    <img className="gallery-list__item__image" src={image.url}
                                         alt="Barkley Square" title="Barkley Square"/>
                                    <div class="caption">
                                        <h3>{image.caption}</h3>
                                        <span>{index + 1} <span>of</span> {this.state.galleryCount}</span>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    </MessagePopup>

                    <MessagePopup onClose={this.showTeamModal} show={this.state.teamOverlayShow}
                                  setClassName="teamModal">
                        <Carousel
                            selectedItem={this.state.teamOverlayPosition}
                            showThumbs={false}
                            onClickItem={false}
                            onSwipeEnd={false}
                            onSwipeStart={false}
                            onSwipeMove={false}
                            swipeable={false}
                            infiniteLoop={true}
                            centerMode={true}
                            centerSlidePercentage={100}
                        >
                            {this.state.teamList.map((team, index) => (
                                <div className="messaging-list__item" key={index}>
                                    <div className="title_wrap">
                                        <img src={team.image.url} alt="Barkley Square" title="Barkley Square"/>
                                        <div className="caption">
                                            <h3 className="messaging-list__item__title">
                                                {team.first_name ? team.first_name : '' + ' ' + team.last_name ? team.last_name : ''}
                                            </h3>
                                            <span class="designation"> {team.designation} </span>
                                        </div>
                                    </div>


                                    <div
                                        className={team.description.trim() == "" ? 'hide' : 'messaging-list__item__info'}>
                                        <p className={this.state.showFullProfile ? '' : 'team_description'}>
                                            {team.description}
                                        </p>

                                        <span onClick={this.setShowFullProfile}
                                              className={this.state.showFullProfile ? "readBtn toggled" : "readBtn unToggled"}>
                                            {this.state.showFullProfile ? 'Read Less' : 'Read More'}
                                        </span>
                                    </div>


                                </div>
                            ))}
                        </Carousel>
                    </MessagePopup>

                    {this.showCarousels()}
                    {this.showParent()}
                    {this.showFoundationPairingsPopup()}
                    {this.litterPopup()}

                    <MessagePopup onClose={this.triggerCotactForm} show={this.state.showContactFomModal}
                                  setClassName="teamModal requestModal">
                        <PetRequestForm
                            pet={this.state.adopts && this.state.adopts.length > 0 ? this.state.adopts[this.state.petOverlayPosition] : null}
                            onClick={this.showSuccessModal}
                            PCBID={this.props.PCBID}/>
                    </MessagePopup>

                    <MessagePopup onClose={this.showFullScreenImg} show={this.state.showFullScreenImg}
                                  setClassName="galleryModal fullScreenModal">
                        {this.imageList()}
                    </MessagePopup>

                    <MessagePopup onClose={this.showRecordsOverlay} show={this.state.showRecordsOverlay}
                                  setClassName="galleryModal recordListModal">
                        <PetRecords
                            pet={this.state.adopts && this.state.adopts.length > 0 ? this.state.adopts[this.state.petOverlayPosition] : null}/>
                    </MessagePopup>

                    <MessagePopup onClose={this.showContactModal} show={this.state.contactOverlayShow}
                                  setClassName="contactModalSubmit">
                        <div className='flex-box'>{this.state.submitMessage}</div>
                        <div className='flex-box'>
                            <button onClick={this.showContactModal} className='btn btn__borderd'>Ok</button>
                        </div>
                    </MessagePopup>

                    <VideoPopup onClose={this.showVideoPlayer} show={this.state.showVideoPlayer} hideClose={false}
                                setClassName="videoModal">
                        {this.videoPlayer()}
                    </VideoPopup>

                    {this.locationList()}

                    <Footer PCBID={this.props.PCBID} businessName={this.state.businessName}/>
                </div>
            );
        } else {
            return (
                this.loadProgressBar()
            )
        }
    }

    locationList = () => {
        if (this.state.locationListStatus) {
            return (
                <MessagePopup onClose={this.showLocationModal} show={this.state.locationOverlayShow}
                              setClassName="messageModal locationModal">
                    <div className='location-list-container'>
                        <h2> {this.state.locationDisplayName} </h2>
                        <ul className='location-list'>
                            {this.state.locations && this.state.locations.map((location) => (
                                <li className='location'>
                                    <img src={location.image} alt=""/>
                                    <div className="list-info">
                                        <h3>{location.name}</h3>
                                        <span>{location.addressOne}<br/>{location.addressTwo}</span>
                                        <span className="miles-away">
                                                {this.state.latitude && this.state.longitude ?
                                                    this.calculateDistance(this.state.latitude, this.state.longitude, location.latitude, location.longitude) + ' miles away' :
                                                    ''
                                                }
                                            </span>
                                    </div>
                                </li>
                            ))}

                        </ul>
                    </div>
                </MessagePopup>
            )
        }
    }

    showLocationModal = (index) => {
        let here = this;
        this.setState({
            locationOverlayShow: !this.state.locationOverlayShow,
            bodyOverflow: !this.state.bodyOverflow,
            messageOverlayPosition: index
        }, function () {
            navigator.geolocation.getCurrentPosition(function (position) {
                here.setState({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                })
            });
        })
        if (here.state.bodyOverflow) {
            document.body.style.overflow = 'unset';
        } else {
            document.body.style.overflow = 'hidden';
        }
    };

    calculateDistance = (lattitude1, longittude1, lattitude2, longittude2) => {
        const toRadian = n => (n * Math.PI) / 180;

        let lat2 = lattitude2;
        let lon2 = longittude2;
        let lat1 = lattitude1;
        let lon1 = longittude1;

        console.log(lat1, lon1 + "===" + lat2, lon2)
        let R = 3958.8  // miles
        let x1 = lat2 - lat1
        let dLat = toRadian(x1)
        let x2 = lon2 - lon1
        let dLon = toRadian(x2)
        let a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRadian(lat1)) * Math.cos(toRadian(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2)
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        let d = R * c
        return d.toFixed(1)
    }

    messageViewer = (message) => {
        if (message.is_enhanced) {
            return <iframe src={message.url + "?from=web"}/>
        } else {
            return (
                <div className="messaging-list__item msg-mid msg-mid-preview msg-mid-view">
                    <img src={message.image.url} alt="Barkley Square" title="Barkley Square"/>
                    <div className="messaging-list__item__desc msg-body-text message-view-text">
                        <div className="messaging-list__item__top">
                            <img src={businessLogo(message)} alt="Barkley Square"
                                 title="Barkley Square"/>
                            <ul>
                                <li><h3
                                    className="messaging-list__item__title">{businessTitle(message)}</h3>
                                </li>
                                <li>{message.sub_category}</li>
                            </ul>
                        </div>
                        <div className="messaging-list__item__copy">
                            <span className="messaging-list__item__copy">{message.title}</span>
                            <p> {message.content.split('\n').map((item, key) => {
                                return <>{item}<br/></>
                            })}
                            </p>
                        </div>
                        {message && message.redirect_name && message.redirect_url ?
                            <div className="serivce-btm-btns" style={{display: 'flex'}}>
                                {this.postRedirectButton(message)}
                            </div>
                            : ''}
                        <div className="messaging-list__item__bottom ">
                                            <span className="like-count"><i
                                                className="ico-like"></i> {message.likes}</span>
                            <span>{formatTimeAgo(message.time)}</span>
                        </div>

                    </div>

                </div>
            )

        }
    }

    showMessages = () => {
        if (this.state.messageEnabled) {
            return <Messaging
                messageList={this.state.messageList}
                onClick={i => this.showMessageModal(i)}
                PCBID={this.props.PCBID}
            />
        }
    }

    showTeamList = () => {
        if (this.state.teamStatus)
            return <Team
                teamList={this.state.teamList}
                onClick={i => this.showTeamModal(i)}
                color={this.props.color}
            />
    }

    showFormList = () => {
        if (this.state.formStatus)
            return <Forms formsList={this.state.formsList}
                          color={this.props.color}
                          PCBID={this.props.PCBID}/>
    }

    showTestimonialList = () => {
        if (this.state.testimonialStatus)
            return <Testimonial
                testimonialList={this.state.testimonialList}
                color={this.props.color}
            />
    }

    showAdoptionPetList() {
        if (this.state.isPetDistributor && (this.props.PCBID === "PCB00108391" || this.props.PCBID === "PCB00108393" || this.props.PCBID === "PCB00108708")) {
            return (
                <Pets
                    adopts={this.state.adopts}
                    foundations={this.state.foundations}
                    pairings={this.state.pairings}
                    onClick={(i, j) => this.showPetModal(i, j)}
                    color={this.props.color}
                    adoptType={this.state.adoptType}
                    PCBID={this.props.PCBID}
                    default_view={this.state.adopt_default_view}
                />
            )
        }
    }

    showServices = () => {
        if (this.state.serviceStatus)
            return <Services
                PCBID={this.props.PCBID}
                color={this.props.color}
                serviceDetails={this.state.serviceDetails}
                serviceType={this.state.serviceType}
                messageEnabled={this.state.messageEnabled}
            />
    }

    loadProgressBar = () => {
        if (this.props.color === "Blue")
            return <div className="progress_bar"><img src={blueColorLoader} alt=''/></div>
        else if (this.props.color === "Purple")
            return <div className="progress_bar"><img src={purpleColorLoader} alt=''/></div>
        else if (this.props.color === "Pink")
            return <div className="progress_bar"><img src={pinkColorLoader} alt=''/></div>
        else if (this.props.color === "Orange")
            return <div className="progress_bar"><img src={orangeColorLoader} alt=''/></div>
        else if (this.props.color === "Green")
            return <div className="progress_bar"><img src={greenColorLoader} alt=''/></div>
        else if (this.props.color === "Red")
            return <div className="progress_bar"><img src={redColorLoader} alt=''/></div>
        else if (this.props.color === "Brown")
            return <div className="progress_bar"><img src={brownColorLoader} alt=''/></div>
        else if (this.props.color === "Charcoal")
            return <div className="progress_bar"><img src={charcoalColorLoader} alt=''/></div>
    }

    handleSelectedMessageItem = (e) => {
        this.setState({messageOverlayPosition: e});
        updateAnalytics('post_click', [this.state.messageList[e].id], this.props.PCBID)
    }

    handleSelectedPet = (e) => {
        this.setState({petOverlayPosition: e});
    }


    showMessageModal = (index) => {
        this.setState({
            messageOverlayShow: !this.state.messageOverlayShow,
            bodyOverflow: !this.state.bodyOverflow,
            messageOverlayPosition: index
        });
        if (this.state.bodyOverflow) {
            document.body.style.overflow = 'unset';
        } else {
            document.body.style.overflow = 'hidden';
        }
    };

    showGalleryModal = (index) => {
        this.setState({
            galleryOverlayShow: !this.state.galleryOverlayShow,
            bodyOverflow: !this.state.bodyOverflow,
            galleryOverlayPosition: index
        });
        if (this.state.bodyOverflow) {
            document.body.style.overflow = 'unset';
        } else {
            document.body.style.overflow = 'hidden';
        }
    };

    showTeamModal = (index) => {
        this.setState({
            teamOverlayShow: !this.state.teamOverlayShow,
            bodyOverflow: !this.state.bodyOverflow,
            teamOverlayPosition: index
        });
        if (this.state.bodyOverflow) {
            document.body.style.overflow = 'unset';
        } else {
            document.body.style.overflow = 'hidden';
        }
    };

    showPetModal = (index, selectedMenu) => {
        this.setState({
            petOverlayShow: !this.state.petOverlayShow,
            bodyOverflow: !this.state.bodyOverflow,
            petOverlayPosition: index,
            selectedMenu: selectedMenu,
            isFoundationDetails: true,
            showParent: false,
            showFoundationPairingDetails: false,
            showLitterDetails: false
        });
        // if (this.state.bodyOverflow) {
        //     document.body.style.overflow = 'unset';
        // } else {
        //     document.body.style.overflow = 'hidden';
        // }
    };

    showParentModal = (parent) => {
        // if else condition to manage back button press in different show case scenarios
        if (this.state.showLitterDetails) {
            let petParent = this.state.foundations.find(el => el.id === parent.id)
            // this is enetered when clicking on parent from litter details popup
            this.setState({
                showLitterDetails: !this.state.showLitterDetails,
                isPairingFlow: true,
                showParent: !this.state.showParent,
                parent: petParent
            })
        } else if (this.state.isPairingFlow) {
            // this is entered when clicking back from parent popup of pairing flow
            this.setState({
                showLitterDetails: !this.state.showLitterDetails,
                isPairingFlow: false,
                showParent: !this.state.showParent
            })
        } else {
            // for all other cases
            let petParent = this.state.foundations.find(el => el.id === parent.id)
            this.setState({
                petOverlayShow: !this.state.petOverlayShow,
                showParent: !this.state.showParent,
                parent: petParent
            });
        }

    };

    showFoundationPairings = (parent) => {
        this.setState({
            petOverlayShow: !this.state.petOverlayShow,
            isFoundationDetails: !this.state.isFoundationDetails,
            showFoundationPairingDetails: !this.state.showFoundationPairingDetails,
            parent: parent
        })
    }

    showPairings = (parent, litter) => {
        this.setState({
            petOverlayShow: !this.state.petOverlayShow,
            isPairingPopup: !this.state.isPairingPopup,
            showLitterDetails: !this.state.showLitterDetails,
            parent: parent,
            litter: litter
        })
    }

    viewRecordLink(pet) {
        if (pet.records && pet.records.length > 0) {
            return (
                <div className="pet-label">
                    <p className="pet-specification">
                        <a className="pet-specification" href onClick={this.showRecordsOverlay}>View Records</a>
                    </p>
                </div>
            )
        }
    }

    showFullScreenImg = () => {
        this.setState({
            showFullScreenImg: !this.state.showFullScreenImg,
            bodyOverflow: !this.state.bodyOverflow,
            petOverlayShow: !this.state.petOverlayShow
        });
        if (this.state.bodyOverflow) {
            document.body.style.overflow = 'unset';
        } else {
            document.body.style.overflow = 'hidden';
        }
    }

    showRecordsOverlay = (event) => {
        event.preventDefault()
        this.setState({
            showRecordsOverlay: !this.state.showRecordsOverlay
        })
    }

    setShowFullProfile = () => {
        this.setState({
            showFullProfile: !this.state.showFullProfile,
            condition: !this.state.condition
        });
    }

    showContactModal = (index) => {
        this.setState({
            contactOverlayShow: !this.state.contactOverlayShow,
            bodyOverflow: !this.state.bodyOverflow,
        });
        if (this.state.bodyOverflow) {
            document.body.style.overflow = 'unset';
        } else {
            document.body.style.overflow = 'hidden';
        }
        if (this.state.submitMessage == '') {
            this.setState({
                submitMessage: 'Thank you for contacting us. \n We will be in touch soon.'.split('\n ').map(i => {
                    return <p>{i}</p>
                })
            });
        } else {
            this.setState({
                submitMessage: ''
            });
        }
    };

    postRedirectButton = (message, type = 'messages') => {
        if (message.link_type === 'url_link' && type === 'messages') {
            return (
                <a href={message.redirect_url} target="_blank" className="btn btn-center btn-secondary"
                   style={{textTransform: 'none', textAlign: 'center'}}
                   onClick={(e) => {
                       updateAnalytics('post_redirect', [message.id], this.props.PCBID)
                   }}>
                    {message.redirect_name}
                </a>
            )
        } else if (message.link_type === 'url_link' && type === 'community') {
            return (
                <a href={message.redirect_url} target="_blank" className="btn btn-center btn-secondary"
                   style={{textTransform: 'none', textAlign: 'center'}}>
                    {message.redirect_name}
                </a>
            )
        } else {
            return (
                <a className="btn btn-center btn-secondary"
                   style={{textTransform: 'none', textAlign: 'center'}}
                   onClick={(e) => this.loadReactPlayer(message.redirect_url)}>
                    {message.redirect_name}
                </a>
            )
        }
    }

    showVideoPlayer = () => {
        if (this.state.activeVideo != null && this.state.showVideoPlayer) {
            this.setState({
                showVideoPlayer: false,
                activeVideo: null,
                messageOverlayShow: true,

            })
        }
    }

    loadReactPlayer = (url) => {
        this.setState({
            showVideoPlayer: true,
            activeVideo: url
        })
    }

    videoPlayer = () => {
        if (this.state.activeVideo && this.state.activeVideo.includes('tiktok')) {
            return (
                <TikTok url={this.state.activeVideo}/>
            )
        } else {
            return (
                <ReactPlayer width='100%'
                             height='500px'
                             style={{maxHeight: '500px'}}
                             controls={true}
                             url={this.state.activeVideo}
                             onReady={e => this.videoLoaded(e)}
                />
            )
        }

    }

    videoLoaded(e) {
        this.setState({
            messageOverlayShow: false
        })
    }

    showSuccessModal = () => {
        this.setState({
            showContactFomModal: false,
            contactOverlayShow: !this.state.contactOverlayShow,
            bodyOverflow: !this.state.bodyOverflow,

        });
        if (this.state.bodyOverflow) {
            document.body.style.overflow = 'unset';
        } else {
            document.body.style.overflow = 'hidden';
        }
        if (this.state.submitMessage == '') {
            this.setState({
                submitMessage: 'Your request has been submitted successfully. \n We will be in touch soon.'.split('\n ').map(i => {
                    return <p>{i}</p>
                })
            });
        } else {
            this.setState({
                submitMessage: ''
            });
        }
    }

    adoptionSlider(images) {
        return (
            <Carousel
                showArrows={false}
                autoPlay={true}
                showThumbs={false}
                width={"100%"}
                infiniteLoop={true}
                interval={2000}
            >
                {images && images.map((image, index) => (
                    <div>
                        <img src={image.url} alt=''/>
                    </div>
                ))}
            </Carousel>
        )
    }

    parentImages(pet) {
        return (
            <div className="pairing-layout">
               <span className='pair-image'><img
                   src={pet.sire.image}
                   alt={pet.sire.name}/>
                </span>
                <span className='pair-image'> <img
                    src={pet.dam.image}
                    alt={pet.dam.name}/>
                </span>
            </div>

        )
    }

    imageList() {
        let position = this.state.petOverlayPosition;
        let images = []
        if (this.state.adopts && this.state.adopts.length >= position + 1)
            images = this.state.adopts && this.state.adopts[position].images
        let count = images && images.length
        return (
            <Carousel
                showArrows={false}
                autoPlay={true}
                showThumbs={false}
                width={"100%"}
                infiniteLoop={true}
                interval={2000}
            >
                {images && images.map((image, index) => (
                    <div className="gallery-list__item gallary-selected-item" key={index}>
                        <img className="gallery-list__item__image" src={image.url}
                             alt="Barkley Square" title="Barkley Square"/>
                        <div class="caption">
                            <span>{index + 1} <span>of</span> {count}</span>
                        </div>
                    </div>
                ))}
            </Carousel>
        )
    }

    showCarousels = () => {
        switch (parseInt(this.state.selectedMenu)) {
            case 0:
                return this.animalForSalePopup()
                break;
            case 1:
                return this.foundationPopup()
                break;
            case 2:
                return this.pairingPopup()
                break;
        }
    }

    returnField = (field, pet) => {
        if (field.question_type === 'predefined_field') {
            return this.generatePredefinedField(field, pet);
        } else {
            return this.generateCustomField(field, pet);
        }
    }

    generatePredefinedField = (field, pet) => {
        switch (field.name) {
            case 'Birthday' :
                return (
                    <div className="pet-label">
                        <p className="pet-specification"> Birthday:</p>
                        <p> {pet.birthday} </p>
                    </div>
                )
            case 'Age' :
                return (
                    <div className="pet-label">
                        <p className="pet-specification"> Age:</p>
                        <p> {pet.age} </p>
                    </div>
                )
            case 'Size' :
                return (
                    <div className="pet-label">
                        <p className="pet-specification"> Size:</p>
                        <p> {pet.size} </p>
                    </div>
                )
            case 'Coat' :
                return (
                    <div className="pet-label">
                        <p className="pet-specification"> Coat:</p>
                        <p className="capitalize"> {pet.coat} </p>
                    </div>
                )
            case 'ChipId' :
                return (
                    <div className="pet-label">
                        <p className="pet-specification"> Chip Id:</p>
                        <p className="capitalize"> {pet.chip_id} </p>
                    </div>
                )
            case 'Spayed' :
                return (
                    <div className="pet-label">
                        <p className="pet-specification"> Spay/Neuter:</p>
                        <p className="capitalize"> {pet.spayed ? "yes" : "no"} </p>
                    </div>
                )
            case 'Description' :
                return (
                    <div className="pet-label">
                        <p className="pet-specification"> Description:</p>
                        <p className="capitalize"> {pet.description} </p>
                    </div>
                )
        }
    }

    generateCustomField = (field, pet) => {
        let answerField = pet.custom_pet_fields && pet.custom_pet_fields.find(el => el.question_id == field.id);
        if (answerField && typeof (answerField) !== 'undefined') {
            return (
                <div className="pet-label">
                    <p className="pet-specification"> {field.name}: </p>
                    <p className="capitalize"> {answerField.answer} </p>
                </div>
            )
        }
    }

    interestedForm = (pet) => {
        return (
            <div className="serivce-btm-btns interested-btn">
                <a href target="_blank" className="btn btn-center btn-secondary"
                   style={{textAlign: 'center'}}
                   onClick={(e) => {
                       this.triggerCotactForm(pet.id)
                   }}>
                    I'm Interested
                </a>
            </div>
        )
    }

    showParent = () => {
        let parent = this.state.parent;
        if (parent) {
            return (
                <MessagePopup onClose={this.showPetModal} show={this.state.showParent} showBackButton={true}
                              onBack={i => this.showParentModal(parent)}
                              setClassName="teamModal petModal animalsForSalePopup">
                    <div className="messaging-list__item" key={this.selectedMenu}>
                        <div className="title_wrap">
                            {this.adoptionSlider(parent.images)}
                        </div>
                        <div className="messaging-list__item__desc pet-container">
                            <div className="messaging-list__item__top adoption-pet-list__item__top">
                                <ul>
                                    <li><h3 className='pet-name'>{parent.name}</h3>
                                    </li>
                                    <li className='sub-title'>
                                        <h4>{`${parent.type}, ${parent.breed}, ${parent.gender}`}</h4></li>
                                </ul>
                            </div>

                            <div
                                className="messaging-list__item__top adoption-pet-list__item__top adoption-pet-list__item__top__parent_info">
                                <ul>
                                    <li className='sub-title'>
                                             <span className='parents'>
                                                <h4>Litters: </h4>
                                                 {
                                                     parent.litters && parent.litters.map((litter, index) => (
                                                         <span href target="_blank"
                                                               className={"parent-btn team_description"}
                                                               style={{textTransform: 'none', textAlign: 'center'}}
                                                         >
                                                                {litter.name}
                                                         </span>
                                                     ))
                                                 }

                                            </span>
                                    </li>
                                </ul>
                            </div>

                            {
                                this.state.petFields && this.state.petFields.map((field, index) => (
                                    this.returnField(field, parent)
                                ))
                            }
                            {this.viewRecordLink(parent)}
                        </div>

                        {this.interestedForm(parent)}
                    </div>
                </MessagePopup>
            )
        }
    }

    animalForSalePopup = () => {
        return (
            <MessagePopup onClose={this.showPetModal} show={this.state.petOverlayShow}
                          setClassName="teamModal petModal animalsForSalePopup animalsForSalePopupOne">
                <Carousel
                    selectedItem={this.state.petOverlayPosition}
                    onChange={(e) => {
                        this.handleSelectedPet(e)
                    }}
                    showThumbs={false}
                    onClickItem={false}
                    onSwipeEnd={false}
                    onSwipeStart={false}
                    onSwipeMove={false}
                    swipeable={false}
                    infiniteLoop={true}
                    centerMode={true}
                    centerSlidePercentage={100}
                >
                    {this.state.adopts.map((pet, index) => (
                        <div className="messaging-list__item" key={index}>
                            <div className="title_wrap">
                                {this.adoptionSlider(pet.images)}
                            </div>

                            <div className="messaging-list__item__desc pet-container">
                                <div className="messaging-list__item__top adoption-pet-list__item__top">
                                    <ul>
                                        <li>
                                            <h3 className='pet-name'>{pet.name}</h3>
                                        </li>
                                        <li className='sub-title'>
                                            <h4>{pet.breed}</h4>
                                        </li>
                                        {/* <li className='sub-title capitalize'>
                                             <span className='carousel-available-image'>
                                                <img className='carousel-available-image'
                                                     src={this.petAdoptionLabel(pet)} alt={pet.adoption_status}/>
                                            </span>
                                        </li> */}
                                        <span className='carousel-gender-label'>
                                            <img className='carousel-gender-label-image'
                                                 src={this.returnGenderLabel(pet)} alt={pet.adoption_status}/>
                                        </span>
                                    </ul>

                                </div>
                                <div className='adoption-pet-list__item__top_status'>
                                        <span className='carousel-available-image'>
                                            <img className='carousel-available-image'
                                                 src={this.petAdoptionLabel(pet)} alt={pet.adoption_status}/>
                                        </span>
                                </div>

                                <div
                                    className="messaging-list__item__top adoption-pet-list__item__top adoption-pet-list__item__top__parent_info ">
                                    <ul>
                                        <li className='sub-title'>
                                             <span className='parents'>
                                                <h4>Parents: </h4>
                                                <span href target="_blank"
                                                      className={`parent-btn ${pet.sire && pet.sire.name && pet.sire.name.length > 5 ? "team_description" : ""}`}
                                                      style={{textTransform: 'none', textAlign: 'center'}}
                                                      onClick={(e) => this.showParentModal(pet.sire)}>
                                                                {pet.sire.name && pet.sire.name.substring(0, 5)}, Sire
                                                </span>
                                                <span href target="_blank"
                                                      className={`parent-btn ${pet.dam && pet.dam.name && pet.dam.name.length > 5 ? "team_description" : ""}`}
                                                      style={{textTransform: 'none', textAlign: 'center'}}
                                                      onClick={(e) => this.showParentModal(pet.dam)}>
                                                    {pet.dam.name && pet.dam.name.substring(0, 5)}, Dam
                                                </span>
                                            </span>
                                        </li>

                                        <li className='sub-title'>
                                             <span className='parents'>
                                                <h4>Litter: </h4>
                                                <span href target="_blank"
                                                      className={`parent-btn ${pet.litter && pet.litter.name && pet.litter.name.length > 5 ? "team_description" : ""}`}
                                                      style={{textTransform: 'none', textAlign: 'center'}}
                                                      onClick={(e) => this.showPairings(pet, pet.litter)}>
                                                                {pet.litter.name && pet.litter.name.substring(0, 10)}
                                                </span>
                                            </span>
                                        </li>

                                    </ul>
                                </div>

                                {
                                    this.state.petFields && this.state.petFields.map((field, index) => (
                                        this.returnField(field, pet)
                                    ))
                                }

                                <div className='row-view-rcd'> {this.viewRecordLink(pet)}</div>

                            </div>

                            {this.interestedForm(pet)}
                        </div>
                    ))}
                </Carousel>
            </MessagePopup>
        )
    }

    returnGenderLabel(pet) {
        if (pet.gender === 'Female') {
            return femaleLabel;
        } else {
            return maleLabel;
        }
    }

    petAdoptionLabel(pet) {
        if (pet.label === 'coming_soon') {
            return comingSoonLabel;
        } else if (pet.label === 'available') {
            return availableLabel;
        } else if (pet.label === 'adopted') {
            return availableLabel;
        } else {
            return ''
        }
    }

    showFoundationPairingsPopup = () => {
        let pet = this.state.parent
        if (pet) {
            return (
                <MessagePopup onBack={i => this.showFoundationPairings(pet)}
                              show={this.state.showFoundationPairingDetails} showBackButton={true}
                              onClose={this.showPetModal} setClassName="teamModal petModal">
                    <div className="messaging-list__item" key={this.selectedMenu}>
                        <div className="title_wrap">
                            {this.adoptionSlider(pet.images)}
                        </div>
                        <div className="messaging-list__item__desc pet-container">
                            <div className="messaging-list__item__top adoption-pet-list__item__top">
                                <ul>
                                    <li><h3>{pet.name}</h3>
                                    </li>
                                    <li><h4>{`${pet.gender} . ${pet.breed}`}</h4></li>
                                </ul>
                            </div>

                            <hr/>
                            <div className='pet-label'>
                                {pet && pet.pairings && pet.pairings.map((pair, index) => (
                                    <>
                                        <img className="pair-icon" src={pair.sire.image}></img>
                                        <img className="pair-icon overlap-image" src={pair.dam.image}></img>
                                        <span>{pair.sire.name} and {pair.dam.name}</span>
                                    </>
                                ))}

                            </div>
                            <hr/>
                            {this.viewRecordLink(pet)}
                        </div>
                        {this.interestedForm(pet)}
                    </div>
                </MessagePopup>
            )
        }
    }

    foundationPopup = () => {
        return (
            <MessagePopup onClose={this.showPetModal} show={this.state.petOverlayShow}
                          setClassName="teamModal petModal animalsForSalePopup">
                <Carousel
                    selectedItem={this.state.petOverlayPosition}
                    onChange={(e) => this.handleSelectedPet(e)}
                    showThumbs={false}
                    onClickItem={false}
                    onSwipeEnd={false}
                    onSwipeStart={false}
                    onSwipeMove={false}
                    swipeable={false}
                    infiniteLoop={true}
                    centerMode={true}
                    centerSlidePercentage={100}
                >
                    {this.state.foundations.map((pet, index) => (
                        <div className="messaging-list__item" key={index}>
                            <div className="title_wrap">
                                {this.adoptionSlider(pet.images)}
                            </div>

                            <div className="messaging-list__item__desc pet-container">
                                <div
                                    className="messaging-list__item__top adoption-pet-list__item__top adoption-pet-list__item__top__foundation">
                                    <ul>
                                        <li>
                                            <h3 className='pet-name'>{pet.name}</h3>
                                        </li>
                                        <li className='sub-title'>
                                            <h4>{pet.breed}</h4>
                                        </li>
                                    </ul>
                                </div>

                                <div
                                    className="messaging-list__item__top adoption-pet-list__item__top adoption-pet-list__item__top__litters">
                                    <ul>
                                        <li className='sub-title'>
                                             <span className='parents'>
                                                <h4>Litters: </h4>
                                                 {
                                                     pet.litters && pet.litters.map((litter, index) => (
                                                         <span href target="_blank"
                                                               className={"parent-btn team_description"}
                                                               style={{textTransform: 'none', textAlign: 'center'}}
                                                         >
                                                                {litter.name}
                                                         </span>
                                                     ))
                                                 }

                                            </span>
                                        </li>
                                    </ul>
                                </div>

                                {
                                    this.state.petFields && this.state.petFields.map((field, index) => (
                                        this.returnField(field, pet)
                                    ))
                                }

                            </div>

                        </div>
                    ))}
                </Carousel>
            </MessagePopup>
        )
    }

    litterPopup = () => {
        let pet = this.state.parent;
        let litter = this.state.litter;
        if (pet && litter) {
            return (
                <MessagePopup onBack={i => this.showPairings(pet, litter)} show={this.state.showLitterDetails}
                              showBackButton={true}
                              onClose={i => this.showPetModal(i)} setClassName="teamModal petModal litterModal">
                    <div className="messaging-list__item pairing-item" key={this.selectedMenu}>
                        <div className='litter-name'>
                            <h3 className='simple-padding spacer-padding'>{litter.name}</h3>
                        </div>

                        <div className='litter-pairing-details simple-padding pairing-layout'>
                            <span href target="_blank"
                                  style={{textTransform: 'none', textAlign: 'center'}}
                                  onClick={(e) => this.showParentModal(pet.sire)}>
                                <img src={pet.sire.image}></img>
                                <div className='litter-pairing-details-info'>
                                    <h3 className='pet-name'>{pet.sire.name}</h3>
                                    <h5>Sire</h5>
                                </div>
                            </span>

                            <span href target="_blank"
                                  style={{textTransform: 'none', textAlign: 'center'}}
                                  onClick={(e) => this.showParentModal(pet.dam)}>
                                <img src={pet.dam.image}></img>
                                <div className='litter-pairing-details-info'>
                                    <h3 className='pet-name'>{pet.dam.name}</h3>
                                    <h5>Dam</h5>
                                </div>
                            </span>
                        </div>

                        <div className='litter-pets-list'>
                            {litter.pets.map((litPet, index) => (
                                <div
                                    className={`adoption-pet-list__item  messaging-list__item animals-for-sale`}
                                    key={index}
                                    data-key={index}
                                >
                                    <div className="messaging-list__item__block">
                                       <span>
                                            <img src={litPet.image} alt={pet.name}/>
                                        </span>
                                        <span className='carousel-gender-label'>
                                            <img className='carousel-gender-label-image'
                                                 src={this.returnGenderLabel(litPet)} alt={litPet.adoption_status}/>
                                        </span>
                                    </div>

                                    <div className="messaging-list__item__desc">
                                        <div className="messaging-list__item__top adoption-pet-list__item__top">
                                            <ul>
                                                <li>
                                                    <h3 className="messaging-list__item__title">{litPet.name}</h3>
                                                </li>
                                                <li>
                                                    <span className='carousel-available-image'>
                                                             <i className={'ico-' + litPet.adoption_status}></i>
                                                             <small>{this.returnAdoptionStatusTxt(litPet.adoption_status)}</small>
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>


                        {this.interestedForm(pet)}
                    </div>
                </MessagePopup>
            )
        }
    }

    returnAdoptionLabel(status) {
        if (status === 'coming_soon') {
            return comingSoonLabel;
        } else if (status === 'available') {
            return availableLabel;
        } else if (status === 'adopted') {
            return availableLabel;
        } else {
            return ''
        }
    }

    returnAdoptionStatus(status) {
        if (status === 'coming_soon') {
            return 'Coming Soon'
        } else if (status === 'available') {
            return 'Available'
        } else if (status === 'adopted') {
            if (this.props.adoptType === "Breeder")
                return 'Purchased'
            else
                return 'Adopted'
        } else {
            return ''
        }
    }

    returnAdoptionStatusTxt(status) {
        if (status === 'coming_soon') {
            return 'Coming Soon'
        } else if (status === 'available') {
            return 'Available'
        } else if (status === 'adopted') {
            return 'Available'
        } else {
            return ''
        }
    }

    pairingPopup = () => {
        return (
            <MessagePopup onClose={this.showPetModal} show={this.state.petOverlayShow}
                          setClassName="teamModal petModal pairModal">
                <Carousel
                    selectedItem={this.state.petOverlayPosition}
                    onChange={(e) => {
                        this.handleSelectedPet(e)
                    }}
                    showThumbs={false}
                    onClickItem={false}
                    onSwipeEnd={false}
                    onSwipeStart={false}
                    onSwipeMove={false}
                    swipeable={false}
                    infiniteLoop={true}
                    centerMode={true}
                    centerSlidePercentage={100}
                >
                    {this.state.pairings.map((pet, index) => (
                        <div className="messaging-list__item pairing-item" key={index}>
                            <div className="title_wrap">
                                {this.parentImages(pet)}
                                <div className="messaging-list__item__top adoption-pet-list__item__top dfsdf">
                                    <ul>
                                        <li>
                                            <h3 className='pet-name'>{pet.sire.name}</h3>
                                        </li>
                                        <li className='sub-title'>
                                            <h4>{`${pet.sire.gender} | ${pet.sire.breed}`}</h4>
                                        </li>
                                    </ul>
                                    <ul>
                                        <li>
                                            <h3 className='pet-name'>{pet.dam.name}</h3>
                                        </li>
                                        <li className='sub-title'>
                                            <h4>{`${pet.dam.gender} | ${pet.dam.breed}`}</h4>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="messaging-list__item__desc pet-container">


                                {
                                    pet.litters.map((litter, index) => (
                                        <div className="litters-list simple-padding spacer-padding pairing-layout">
                                            <span><p><b>{litter.name}:</b></p></span>
                                            <span>
                                                    <a className='btn' href target="_blank"
                                                       style={{textTransform: 'none', textAlign: 'center'}}
                                                       onClick={(e) => this.showPairings(pet, litter)}>
                                                        View
                                                    </a>
                                                </span>
                                        </div>
                                    ))
                                }

                                {this.viewRecordLink(pet)}
                            </div>
                            {this.interestedForm(pet)}

                        </div>
                    ))}
                </Carousel>
            </MessagePopup>
        )
    }

}

export default App;

